<div class="modal-backdrop fade show"></div>
<div class="modal-dialog" role="document">
  <div class="modal-content">
    <div class="modal-header">
     <ng-content select="pcs-modal-header"></ng-content>
    </div>
    <div class="modal-body">
      <ng-content select="pcs-modal-body"></ng-content>
    </div>
    <div class="modal-footer">
      <ng-content select="pcs-modal-footer"></ng-content>
    </div>
  </div>
</div>
